import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { environment } from "src/environments/environment";

const LEGACY_TO_REACT_ROUTE_MAP: Record<string, string> = {
  "/auto": "/new/auto",
  "/contacto": "/new/contacto",
  "/beneficios-clientes/referidos": "/new/beneficios-clientes/referidos",
  "/celu": "/new/celu",
  "/pertenencias-personales": "/new/pertenencias-personales",
  "/mascotas": "/new/mascotas",
  "/hogar": "/new/hogar",
  "/movilidad": "/new/movilidad",
  "/accidentes-personales": "/new/accidentes-personales",
  "/moto": "/new/moto",
  "/asistenciaviajero": "/new/asistenciaviajero",
  "/blog": "/new/blog",
  "/quienes-somos": "/new/quienes-somos",
  "/preguntas-frecuentes": "/new/preguntas-frecuentes",
  "/terminos-y-condiciones": "/new/terminos-y-condiciones",
  "/libro-quejas": "/new/libro-quejas"
};

const ROUTES_WITHOUT_QUERY_PARAMS: Record<string, boolean> = {
  "/auto": true
};

@Injectable({
  providedIn: "root"
})
export class HomeRedirectGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.shouldAllowNavigation(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.shouldAllowNavigation(state.url);
  }

  private shouldAllowNavigation(url: string): boolean {
    const parsedUrl = new URL(url, window.location.origin);
    const pathname = this.normalizePathname(parsedUrl.pathname);

    if (this.isReactPath(pathname)) {
      return true;
    }

    const destinationPath = this.getDestinationPath(pathname);

    if (!destinationPath) {
      return true;
    }

    const destinationUrl = this.buildDestinationUrl(pathname, destinationPath, parsedUrl);

    if (this.isSameDestination(destinationUrl)) {
      return true;
    }

    window.location.replace(destinationUrl);
    return false;
  }

  private isReactPath(pathname: string): boolean {
    return pathname === "/new" || pathname.startsWith("/new/");
  }

  private getDestinationPath(pathname: string): string | null {
    if (pathname === "/") {
      return "/new";
    }

    return LEGACY_TO_REACT_ROUTE_MAP[pathname] || null;
  }

  private buildDestinationUrl(pathname: string, destinationPath: string, parsedUrl: URL): string {
    const keepQueryParams = !ROUTES_WITHOUT_QUERY_PARAMS[pathname];
    const query = keepQueryParams ? parsedUrl.search : "";

    return `${environment.frontendNewUrl}${destinationPath}${query}`;
  }

  private isSameDestination(destinationUrl: string): boolean {
    return this.normalizeAbsoluteUrl(window.location.href) === this.normalizeAbsoluteUrl(destinationUrl);
  }

  private normalizeAbsoluteUrl(value: string): string {
    const parsedUrl = new URL(value, window.location.origin);
    const normalizedPathname = this.normalizePathname(parsedUrl.pathname);

    return `${parsedUrl.origin}${normalizedPathname}${parsedUrl.search}${parsedUrl.hash}`;
  }

  private normalizePathname(pathname: string): string {
    if (!pathname || pathname === "/") {
      return "/";
    }

    return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  }
}